<div class="login-body">
  <mat-card appearance="outlined" class="example-card">
    <mat-card-content>
      <form (ngSubmit)="onSubmit()" [formGroup]="loginForm">
        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Email</mat-label>
            <input formControlName="email" id="email" matInput name="email" type="text">
          </mat-form-field>

        </div>
        <div class="form-row">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Password</mat-label>
            <input formControlName="password" id="password" matInput name="password" type="password" [errorStateMatcher]="passwordErrorStateMatcher">
            <mat-error *ngIf="loginError">{{ loginError }}</mat-error>
          </mat-form-field>
        </div>
        <div class="form-row-login-btn">
          <button class="loginBtn" color="primary" mat-raised-button type="submit" [disabled]="loading">
            <mat-progress-spinner *ngIf="loading" diameter="20" mode="indeterminate"></mat-progress-spinner>
            <span *ngIf="!loading">CONTINUE</span>
          </button>
        </div>
      </form>
      <div class="text-center">
        <a routerLink="/forgot-password">Forgot password?</a>
      </div>
    </mat-card-content>
  </mat-card>
</div>
